import React from "react";
import PageTab from "external/reports/officeStats/ui/pageTabs/PageTab";
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class PageTabs extends React.Component {
    render() {
        let { activePage } = this.props;
        return (React.createElement(FlexContainer, null,
            React.createElement("div", { className: "tabbable-line" },
                React.createElement("ul", { className: "nav nav-tabs" },
                    React.createElement(PageTab, { label: "Summary", isActive: activePage == 1, callback: () => this.props.summaryCallback() }),
                    React.createElement(PageTab, { label: "Sales", isActive: activePage == 2, callback: () => this.props.salesCallback() }),
                    React.createElement(PageTab, { label: "Rentals", isActive: activePage == 3, callback: () => this.props.rentalsCallback() }),
                    React.createElement(PageTab, { label: "Development", isActive: activePage == 4, callback: () => this.props.developmentCallback() }),
                    React.createElement(PageTab, { label: "Billboards", isActive: activePage == 5, callback: () => this.props.billboardsCallback() })))));
    }
}
